// extracted by mini-css-extract-plugin
export default {"element":"LayoutRow-module--element--acf7c","capped":"LayoutRow-module--capped--ea18a"};